// 带生成标签的路由跳转

export default async function goPath(menu) {
  const url = menu.ASSEMBLY;
  if (this.$route.path !== url) await this.$router.push(url).catch(e => {
    console.error('go path error', e);
  });

  this.$store.commit('setActiveMenu', menu);
  this.$store.commit('addMenuTab', menu);
}
